import useFindInvoicesQuery from '@/api/queries/useFindInvoicesQuery';
import PageHeader from '@/components/PageHeader';
import { InvoiceStatus } from '@/models/Invoice';
import InvoiceStatusSelectBox from '@/modules/billing/components/InvoiceStatusSelectBox';
import InvoiceTable from '@/modules/billing/components/InvoiceTable';
import { BillingInvoiceDetailsPath } from '@/modules/billing/paths';
import { useSearchParams } from 'react-router-dom';

const InvoiceList = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = Math.max(Number(searchParams.get('page')) || 1, 1);
  const statusParam = searchParams.get('status');
  const status = statusParam ? (statusParam as InvoiceStatus) : undefined;
  const { invoices, isLoading, isFetching, itemsPerPage } = useFindInvoicesQuery(page, { status });

  const updateSearchParams = (nextPage: number, nextStatus?: InvoiceStatus) => {
    const params = new URLSearchParams();

    if (nextPage > 1) {
      params.set('page', String(nextPage));
    }

    if (nextStatus) {
      params.set('status', nextStatus);
    }

    setSearchParams(params);
  };

  const handleStatusChange = (nextStatus?: { id: string } | null) => {
    updateSearchParams(1, nextStatus?.id as InvoiceStatus | undefined);
  };

  const handlePageChange = (nextPage: number) => {
    updateSearchParams(nextPage, status);
  };

  return (
    <>
      <PageHeader title="Invoices" />

      <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-end">
        <div className="sm:w-96 lg:w-80">
          <InvoiceStatusSelectBox value={status ?? null} onSelect={handleStatusChange} />
        </div>
      </div>

      <InvoiceTable
        invoices={invoices.items}
        page={page}
        itemsPerPage={itemsPerPage}
        totalCount={invoices.totalCount}
        estimatedTotalCount={invoices.estimatedTotalCount}
        isLoading={isLoading}
        isFetching={isFetching}
        onChangePage={handlePageChange}
        getInvoicePath={BillingInvoiceDetailsPath.withId}
      />
    </>
  );
};

export default InvoiceList;
